import React from "react";
import { Box, VStack, Link, Icon, Text } from "@chakra-ui/react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import {
  FiGrid,
  FiUsers,
  FiTv,
  FiMusic,
  FiFilm,
  FiYoutube,
  FiDollarSign,
  FiHelpCircle,
  FiSettings,
  FiClipboard,
  FiUpload,
} from "react-icons/fi";
import { FaUniversity } from "react-icons/fa";

const menuItems = [
  { icon: FiGrid, label: "대시보드", href: "/admin/dashboard" },
  { icon: FiUsers, label: "사용자", href: "/admin/users" },
  { icon: FiTv, label: "채널", href: "/admin/channels" },
  { icon: FiMusic, label: "음악", href: "/admin/music" },
  { icon: FiYoutube, label: "영상", href: "/admin/videos" },
  { icon: FiClipboard, label: "영상 신청", href: "/admin/video-applications" },
  { icon: FiFilm, label: "영상 수익", href: "/admin/video-revenue" },
  { icon: FiMusic, label: "음원 수익", href: "/admin/shorts-music-revenue" },
  { icon: FaUniversity, label: "음원 정산", href: "/admin/settlement" },
  { icon: FiUpload, label: "영상 정산", href: "/admin/video-settlement" },
  { icon: FiDollarSign, label: "정산 신청", href: "/admin/settlement-request" },
  { icon: FiHelpCircle, label: "FAQ / 공지사항", href: "/admin/support" },
  { icon: FiSettings, label: "홈페이지 관리", href: "/admin/homepage" },
];

const Sidebar = () => {
  const location = useLocation();

  return (
    <Box
      minW="250px"
      w="250px"
      bg="white"
      h="calc(100vh - 60px)"
      p={5}
      borderRight="1px solid #e2e8f0"
      position="sticky"
      top="60px"
    >
      <VStack align="stretch" spacing={2}>
        {menuItems.map((item) => (
          <Link
            as={RouterLink}
            to={item.href}
            key={item.label}
            p={3}
            borderRadius="md"
            display="flex"
            alignItems="center"
            bg={
              location.pathname === item.href
                ? "blue.50"
                : "transparent"
            }
            color={
              location.pathname === item.href ? "blue.600" : "gray.600"
            }
            fontWeight={
              location.pathname === item.href ? "bold" : "normal"
            }
            _hover={{
              bg: "blue.50",
              color: "blue.600",
            }}
          >
            <Icon as={item.icon} mr={3} w={5} h={5} />
            <Text>{item.label}</Text>
          </Link>
        ))}
      </VStack>
    </Box>
  );
};

export default Sidebar;
